const getDataUrlFromBlob = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => resolve(event.target.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })

export default getDataUrlFromBlob
